import {
  FavoritesListsContext,
  FavoritesListsConsumer,
  FavoritesListsProvider
} from './favorites-lists-context';

export { FavoritesListsContext, FavoritesListsConsumer, FavoritesListsProvider };

export default FavoritesListsContext;
